import React,{useEffect,useState} from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { Container, Row, Col, Tab, Form,Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import {BASE_URL} from '../../lib/constant';
import { Flip, Slide, toast } from 'react-toastify';
import CustomTable from './CustomTable'
import "./Staff.styles.css";

const Staff = () => {

  const [logedIn, setLogedIn] = useState(false);
    const [userDetails, setUserDetails] = useState(false);
    const [staffs, setStaffs] = useState(false);
    const [selectedStaff, setSelectedStaff] = useState(false);
    const [dmShow, setDmShow] = useState(false);
    const [emShow, setEmShow] = useState(false);


    // Get Staff List
    // https://devb2b.bizpoint-intl.com:3082/api/corporate/user/ARM-22000075
    async function getStaffs () {
        // userDetails.arnum="ARM-90212518";
        await Axios.get(`/corporate/user`)
        .then(async (data) => {
            if (data.status == 200 && data.data?.data?.users) {
              setStaffs(data.data.data.users);
            }
        })
    }

    async function addNewCatalog (values) {
        await Axios.post(`/corporate/catalog/${userDetails.arnum}`,{
          "catalog": {
            "catalogname": values.catalogname
          }
        })
        .then(async (catalogs) => {
          getStaffs(userDetails.refnum);
          toast.success('New catalog added successfully', {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              transition: Slide,
          });
          setEmShow(false);
        })
    }

    async function deleteCatalog () {
      if(selectedStaff){
        await Axios.delete(`/corporate/catalog/${userDetails.arnum}/${selectedStaff}`)
        .then(async (catalogs) => {
          getStaffs(userDetails.refnum);
          toast.success('Catalog deleted successfully', {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              transition: Slide,
          });
          setDmShow(false);
        })
      }
    }

    useEffect(() => {
        if(logedIn)setUserDetails(AuthVerify.getUser());
    }, [logedIn]);


  return (
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>Staff</h2>
        </div>
        <div className="welcome-msg">
                  <h4>Staff Account Information</h4>
                  {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas quis ex eleifend, facilisis enim eget,
                    eleifend purus. Donec dictum elit quis condimentum finibus.</p> */}
                </div>
        <hr/>
        <div className="dashboard">
          {/* <div className="box-account" style={{ display: "grid" }}>
            <div className="page-title">
              <h3 className="checkout-sep">Staff Listing</h3>
            </div>
            <div className="box-account" style={{ display: "grid",paddingTop:"0px" }}>
          <div className="toolbar" style={{paddingBottom:"0px"}}>
              <div className="row">
              <Col sm={4}>
                <input type="text" placeholder="Search..." style={{marginRight: "0px",padding:"4px"}} />
                <button type="button" style={{ padding:"5px 10px", borderRadius:"3px"}}>
                    <span className="glyphicon glyphicon-search"></span>
                </button>
              </Col>
                {addNewPermission &&
                <div className="col-sm-3 text-right" style={{float:"right"}}>
                  <a href="#" onClick={()=>setEmShow(true)}>+ Add New Staff</a>
                </div>}
              </div>
            </div>
          </div>
          </div>
          <div className="box-account" style={{ display: "grid" }}>
            <div className="order-detail-content">
                <Table responsive className="osya table-bordered">
                    <thead>
                        <tr>
                            <th className="cart_product">#SL</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>User Name</th>
                            <th className="action"></th>
                        </tr>
                    </thead>
                    <tbody>
                      {staffs && staffs.map((item,i)=>{
                        return (
                          <tr key={i}>
                            <td>{i+1}</td>
                            <td>{item.firstname}</td>
                            <td>{item.lastname}</td>
                            <td>{item.username}</td>
                            <td>
                              {viewPermission && <Link to={`/staff-details?ctrnum=${item.ctrnum}`}>View</Link>} {" "} 
                              {editPermission && <Link to={`/staff-details?ctrnum=${item.ctrnum}`}>Edit</Link>} {" "} 
                              {deletePermission && <Link to="/shopping-cart">Delete</Link>} {" "}
                              </td>
                          </tr>
                        );
                      })}
                    </tbody>
                </Table>
            </div>
          </div>
          <br /> */}
          <CustomTable/>
        </div>
      </div>
    </div>
  );
};

export default Staff;
